import BaseList from './BaseList';
import type CityData from './CityData';

/**
 * Wrapper to manage lists of places (cities).
 *
 * Las ciudades se construyen desde features del mapa (CityData.fromMapFeature),
 * no desde un listado REST: el catalogo de /data/city_list.json lo guarda
 * CityStorage como objetos crudos para el buscador. Por eso aqui no hay
 * fromListItems, al contrario que en las demas listas.
 */
class CityList extends BaseList<CityData> {
    
    // Max list size.
    maxSize = 10;
    
}

export default CityList;
